<script setup lang="ts">
import { storeToRefs } from "pinia";
import ActionStatusBtn from "~/components/Pages/training-plan/project/steps/project-type/ActionStatusBtn.vue";
import { useCreateTrainingStore } from "~/store/trainings/create-training.store";
import { TrainingTypeEnum } from "~/utils/enums/training.enums";
import SvgIcon from "~/components/Common/SvgIcon.vue";
import { useCreateBuilderTrainingStore } from "~/store/trainings/create-training-builder.store";

const createTrainingStore = useCreateTrainingStore();
const createBuilderTrainingStore = useCreateBuilderTrainingStore();
const { training } = storeToRefs(createTrainingStore);

const openBuilderModal = () => {
  training.value.general.type = TrainingTypeEnum.INTERNAL_BUILDER;
  createTrainingStore.showModal = false;
  createBuilderTrainingStore.openTrainingModal();
};
</script>

<template>
  <h3 class="heading_3_demi p-[8px] mb-[16px]">Quel type de formation interne souhaitez-vous créer ?</h3>
  <div class="grid px-4">
    <div class="flex flex-col justify-between gap-2 gap-x-2 pb-4">
      <ActionStatusBtn @click="training.general.type = TrainingTypeEnum.INTERNAL">
        <template #title>
          <SvgIcon class="h-[24px] w-[24px] text-secondary-color" name="presential"></SvgIcon>
          Formation en classe (présentiel,visio)
        </template>
      </ActionStatusBtn>
      <ActionStatusBtn @click="openBuilderModal">
        <template #title>
          <SvgIcon class="h-[24px] w-[24px] text-secondary-color" name="web"></SvgIcon>
          Formation eLearning
        </template>
      </ActionStatusBtn>
      <ActionStatusBtn class="hidden-button">
        <template #title>
          <SvgIcon class="h-[24px] w-[24px] text-medium-grey-color" name="blended"></SvgIcon>
          <div class="text-medium-grey-color">Formation mixte : “live” + activités en ligne (bientôt disponible)</div>
        </template>
      </ActionStatusBtn>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "assets/scss/texts";

.hidden-button:hover {
  cursor: unset;
  border-color: var(--grey-lightest) !important;
}
</style>
